<template>
  <div class="editable-cell">
    <vxe-table
      border
      resizable
      show-overflow
      ref="xTable"
      max-height="500"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
      <vxe-table-column type="seq" width="50" v-if="!edit"></vxe-table-column>
      <vxe-table-column field="managerId" title="姓名" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatManagerId(row.managerId) }}</span>
        </template>
        <template #edit="{ row }">
          <el-select v-model="row.managerId" filterable transfer placeholder="请选择" size="small" :disabled="edit">
            <el-option v-for="item in managerList" :key="item.opId" :value="item.opId" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column field="mediaId" title="媒体" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatMediaId(row.mediaId) }}</span>
        </template>
        <template #edit="{ row }">
          <el-select v-model="row.mediaId" placeholder="请选择" transfer filterable size="small" :disabled="edit">
            <el-option v-for="item in mediaData" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column field="mgameId" width="120" title="中间件游戏" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatMgameId(row.mgameId) }}</span>
        </template>
        <template #edit="{ row }">
          <el-select v-model="row.mgameId" placeholder="请选择" transfer filterable size="small" :disabled="edit">
            <el-option v-for="item in middleGameList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column field="platform" title="平台" :edit-render="{}">
        <template #default="{ row }">
          <span>{{ formatPlatform(row.platform) }}</span>
        </template>
        <template #edit="{ row }">
          <el-select v-model="row.platform" placeholder="请选择" transfer filterable size="small" :disabled="edit">
            <el-option v-for="item in platformData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column field="mondayVal" title="周一" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.mondayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="tuesdayVal" title="周二" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.tuesdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="wednesdayVal" title="周三" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.wednesdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="thursdayVal" title="周四" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.thursdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="fridayVal" title="周五" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.fridayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="saturdayVal" title="周六" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.saturdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="sundayVal" title="周日" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.sundayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="control" title="操作" v-if="!edit">
        <template #default="scope">
          <el-button type="text" size="small" @click="$emit('on-copy', scope.row)">复制</el-button>
          <el-button type="text" size="small" @click="$emit('on-delete', scope.rowIndex)" v-if="tableData.length > 1">删除</el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
import InputNumberPlus from '@/components/input/input-number-plus'
import promote_media from '@/data/promote_media'
export default {
  name: 'EditTable',
  components: {
    InputNumberPlus
  },
  props: {
    managerList: {
      type: Array
    },
    middleGameList: {
      type: Array
    },
    platformData: {
      type: Array
    },
    tableData: {
      type: Array
    },
    edit: {
      type: Boolean
    }
  },
  computed: {
    transTableData() {
      return JSON.parse(JSON.stringify(this.tableData))
    }
  },
  watch: {
    deep: true,
    transTableData: {
      handler(nVal) {
        // console.log(nVal)
      }
    }
  },
  data() {
    return {
      mediaData: promote_media
    }
  },
  methods: {
    formatManagerId(id) {
      const item = this.managerList.filter((ret) => ret.opId === id)
      if (item.length) return item.pop().name
      else return '请选择'
    },
    formatMediaId(id) {
      const item = this.mediaData.filter((ret) => ret.value === id)
      if (item.length) return item.pop().label
      else return '请选择'
    },
    formatMgameId(id) {
      const item = this.middleGameList.filter((ret) => ret.id === id)
      if (item.length) return item.pop().name
      else return '请选择'
    },
    formatPlatform(id) {
      const item = this.platformData.filter((ret) => ret.id === id)
      if (item.length) return item.pop().name
      else return '请选择'
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .vxe-cell--edit-icon {
  display: none;
}
</style>
